var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMzn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4847 16.9626L3.51367 20.7519C5.68511 22.9236 8.68478 24.267 11.9986 24.267C16.9593 24.267 21.2162 21.2563 23.0438 16.9626H6.4847Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0624 7.61513C21.2451 3.29837 16.9761 0.267334 11.9986 0.267334C8.68478 0.267334 5.68511 1.61072 3.51367 3.78244L6.51883 7.61513H23.0624Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60938 9.09155V15.3959H23.5873C23.8565 14.3979 24.0007 13.3486 24.0007 12.2655C24.0007 11.1666 23.8526 10.1026 23.5759 9.09155H2.60938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.78296C-1.17157 8.46924 -1.17157 16.0673 3.51471 20.7536C5.45126 18.817 7.31374 16.9546 12 12.2683L3.51471 3.78296Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85792 9.13843L5.63487 11.5298H8.14953L6.11525 13.0079L6.89216 15.3993L4.85792 13.9213L2.82359 15.3993L3.60069 13.0079L1.56641 11.5298H4.08087L4.85792 9.13843Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13198 12.2673H2.58398V14.3543H7.13198V12.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9935 9.87243L7.25564 9.13452L4.85808 11.5321L2.46052 9.13452L1.72266 9.87243L4.12233 12.2678L1.72266 14.6676L2.46052 15.3954L4.85808 13.0022L7.25564 15.3954L7.9935 14.6676L5.59383 12.2678L7.9935 9.87243Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMzn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MZN.420e31dd05c952a615a3da2277d4bdcf.svg";